// noinspection DuplicatedCode

import TaxPayer from "app/pages/taxPayers/models/TaxPayer";
import { formatCurrency } from "cofa/utils/functions/text";
import { withStatus, withTimesTamps } from "app/pages/receipts/models/commons";

class ParkingDepositReceipt {
  ref;
  code;
  plate;
  amount;
  paymentDate;
  agentId;
  agentName;
  agentDepositDate;
  agentDepositRef;
  cashierId;
  cashierName;
  cashierDepositDate;
  canceled;
  canceledAt;
  canceledBy;
  canceledByName;
  longitude;
  latitude;
  taxPayer;
  status;
  searchSlug;
  paymentMode;

  constructor(receipt) {
    Object.assign(this, receipt);
  }

  static fromJson(receipt) {
    return new ParkingDepositReceipt({
      ref: receipt["ref"],

      code: receipt["code"],
      plate: receipt["plate"],

      amount: receipt["amount"],
      paymentDate: receipt["payment_date"],

      agentId: receipt["agent_id"],
      agentName: receipt["agent_name"],
      agentDepositDate: receipt["agent_deposit_date"],
      agentDepositRef: receipt["agent_deposit_ref"],

      deposed: !!receipt["agent_deposit_date"],
      collected: !!receipt["agent_deposit_date"],

      cashierId: receipt["cashier_id"],
      cashierName: receipt["cashier_name"],
      cashierDepositDate: receipt["cashier_deposit_date"],

      canceled: !!receipt["canceled_at"],
      notCanceled: !receipt["canceled_at"],
      canceledAt: receipt["canceled_at"],
      cancelReason: receipt["cancel_reason"],
      canceledBy: receipt["canceled_by_id"],
      canceledByName: receipt["canceled_by_name"],

      longitude: receipt["longitude"],
      latitude: receipt["latitude"],

      taxPayer: receipt["tax_payer"] && TaxPayer.fromJson(receipt["tax_payer"]),

      ...withTimesTamps(receipt),
      ...withStatus(receipt),
    });
  }

  getLabelFr(modes) {
    return (
      modes.find((mode) => mode.code === this.paymentMode)?.label ??
      this.paymentMode
    );
  }

  getSearchSlug(additionalValues = []) {
    return [
      ...additionalValues,
      this.ref,
      this.code,
      this.plate,
      this.taxPayer?.ref,
      this.taxPayer?.address,
      this.taxPayer?.phone,
      this.taxPayer?.nif,
      this.taxPayer?.address,
      this.taxPayer?.firstName,
      this.taxPayer?.lastName,
      this.amount,
      formatCurrency(this.amount),
      this.paymentMode,
      this.agentId,
      this.agentName,
      this.agentDepositRef,
      this.cashierId,
      this.cashierName,
      this.status,
      this.canceledBy,
      this.canceledByName,
    ].join("");
  }

  populateWithData({ paymentModes = [] }) {
    //Translate Payment mode to French.
    this.paymentModeFr = this.getLabelFr(paymentModes);

    //Generate search slug that easier search.
    this.searchSlug = this.getSearchSlug([this.paymentModeFr]);

    //Use this method in fluent mode.
    return this;
  }

  asCanceled() {
    this.amount = -1 * this.amount;
    this.canceled = true;

    return this;
  }

  removeCanceledState() {
    this.canceled = false;

    this.canceledAt = null;
    this.canceledBy = null;
    this.canceledByName = null;
    this.cancelReason = null;

    return this;
  }
}

export default ParkingDepositReceipt;
